// more load
$(function(){
	
	//分割したい個数を入力
	var division = 10;
	
	//要素の数を数える
	var divlength = $('#sulci-members li').length;
	//分割数で割る
	dlsizePerResult = divlength / division;
	//分割数 刻みで後ろにmoreを追加する
	for(i=1;i<=dlsizePerResult;i++){
		$('#sulci-members li').eq(division*i-1)
                .after('<a class="btn sulciBtn-large sulciBtn-more link'+i+'">MORE</a>');
	}
	//最初のli（分割数）と、moreを残して他を非表示
	$('#sulci-members li,.fromcebu-members .sulciBtn-more').hide();
	for(j=0;j<division;j++){
		$('#sulci-members li').eq(j).show();
	}
	$('.fromcebu-members .sulciBtn-more.link1').show();
	
	//moreにクリック時の動作
	$('.fromcebu-members .sulciBtn-more').click(function(){
		//何個目のmoreがクリックされたかをカウント
		index = $(this).index('.fromcebu-members .sulciBtn-more');
		//(クリックされたindex +2) * 分割数 = 表示数
		for(k=0;k<(index+2)*division;k++){
			$('#sulci-members li').eq(k).fadeIn();
		}
		
		//一旦全てのmore削除
		$('.fromcebu-members .sulciBtn-more').hide();
		//次のmore(index+1)を表示
		$('.fromcebu-members .sulciBtn-more').eq(index+1).show();
	
	});
	
});

// ページプルダウン変更時にページ遷移
$('select[name=pagejump]').change(function() {
  var urlParam = location.search.substring(1);
  var url = decodeURIComponent(location.search.substring(1));
  var param = url.split('&');

  if ($(this).val() != '') {
    if(urlParam.indexOf('sort=') !== -1) {
      window.location.href = '?' + param[0] + '&page=' + $(this).val();
    }
    else if(urlParam.indexOf('query=') !== -1) {
      window.location.href = '?' + param[0] + '&page=' + $(this).val();
    }
    else {
      window.location.href = '?page=' + $(this).val();
    }
  }
  var browser = document.page.value;
  location.href = browser
  $('option').val($(this).val());
});

// eclipse text

const addTruncationCSS = (element, lineNumber) => {

  if('WebkitLineClamp' in element.style) {

    element.style.display = '-webkit-box';
    element.style.WebkitLineClamp = lineNumber;
    element.style.WebkitBoxOrient = 'vertical';
    element.style.overflow = 'hidden';

  } else {

    // IE11などline-clamp非対応の処理
    const limitHeight = parseFloat(getComputedStyle(element).lineHeight) * Number(lineNumber);
    element.style.overflowY = 'hidden';
    element.style.height = String(limitHeight) + 'px';
  }
}

const truncationElements = document.querySelectorAll('[data-truncation]');

if(truncationElements) {
  for (const elemet of truncationElements) {
    const lineNumber = elemet.dataset.truncation;
    addTruncationCSS(elemet, lineNumber);
  }
}

// popup
// $(function() {

//   for(let i = 0; i < 40; i++) {
//       var modalOpen = `#sulci-modal-open-${ i + 1}` ;
//       var modalBox = `#display-modal-${ i + 1}` ;
//       var modalClose = `#display-modal-${ i + 1} .sulci-modal-bg,#display-modal-${ i + 1 } .sulciBtn-close` ;

//      $(modalOpen).click(function(){
//       $(modalBox).fadeIn();
//       $('html').addClass('modalset');
//      });
//      $(modalClose).click(function(){
//       $(modalBox).fadeOut();
//       $('html').removeClass('modalset');
//      });
    
//     break;
//   }
  
//   document.getElementById('koko').innerHTML = modalOpen ;

// });	

//modal2
// Open the Modal
function openModal() {
  document.getElementById("myModal").style.display = "block";
}

// Close the Modal
function closeModal() {
  document.getElementById("myModal").style.display = "none";
}

var slideIndex = 1;
showSlides(slideIndex);

// Next/previous controls
function plusSlides(n) {
  showSlides(slideIndex += n);
}

// Thumbnail image controls
function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
  var i;
  var slides = document.getElementsByClassName("sulci-modal-wrap");
  if (n > slides.length) {slideIndex = 1}
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  slides[slideIndex-1].style.display = "block";
}


// 確認メール
function CheckEmail(input){
    //IE対応の為変更
    //var mail = email_2.value; //メールフォームの値を取得
    var mail = document.getElementById("ContactForm-email").value; //メールフォームの値を取得
    var mailConfirm = input.value; //メール確認用フォームの値を取得(引数input)

    // パスワードの一致確認
    if(mail != mailConfirm){
      input.setCustomValidity('メールアドレスが一致しません'); // エラーメッセージのセット
    }else{
      input.setCustomValidity(''); // エラーメッセージのクリア
    }
}

//スマホ、タブレットでhover無効
addEventListener('DOMContentLoaded', function(){
    if( isTouchDevice() ){
        for( var i in document.styleSheets ) if( document.styleSheets.hasOwnProperty(i) ){
            deleteRuleHover(document.styleSheets[i]);
        }
    }
    function isTouchDevice() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints || navigator.msMaxTouchPoints;
    }
    function deleteRuleHover( styleSheet ){
        try{
            var rules = styleSheet.cssRules || styleSheet.rules;
            if( rules ){
                for( var i=rules.length; i--; ){
                    var text = rules[i].selectorText;
                    if( /:hover/.test(text) ){
                        //console.log(text);
                        styleSheet.deleteRule(i);
                    }
                }
                for( var i=rules.length; i--; ) deleteRuleHover(rules[i]);
            }
        }
        catch(ex){
            //console.log(ex);
        }
    }
});

